<template lang='pug'>
#app.partners(data-app)
  loading(ref='loading', @interrupt='$emit("interrupt")')
  app-frame(ref='frame', @showMenu='dialogMenu = true')
    router-view(v-if='ready')
  number-input-modal(ref='numberInput')
  v-dialog(v-model='dialogMenu', fullscreen, transition='slide-x-reverse-transition')
    app-menu(@close='dialogMenu = false', @goto='go', @logout='onClickLogout', :items='menuItems')
  confirm(ref='confirm')
</template>

<script>
import AppFrame from '@/components/appFrame'
import NumberInputModal from '@/components/productionStatus/numberInputModal'
import AppMenu from '@/components/menu'
import api from '@/api'
import lodash from 'lodash'
import { mapActions, mapState, mapMutations } from 'vuex'
import Confirm from '@/components/ui/confirm'
import loading from '@/components/ui/loading'

export default {
  computed: { ...mapState(['settings', 'user']) },
  components: { AppFrame, NumberInputModal, AppMenu, Confirm, loading },
  name: 'Partners',
  async created () {
    this.loadToken()
    api.setToken(this.user.token)
    window.App = this
    await this.loadSiteConfig()
    this.$root.$showLoading()
    try {
      await this.tryToLoadSetting()
      await this.loadLogged()
    } catch (e) {
      this.$router.push('/Login')
    }
    this.$root.$hideLoading()
    this.ready = true
    this.initErrorHandler()
  },
  mounted () {
    this.$root.$confirm = this.$refs.confirm.open
    this.$root.$showLoading = this.$refs.loading.show
    this.$root.$hideLoading = this.$refs.loading.hide
  },
  data: () => ({
    ready: false,
    dialogMenu: false,
    menuItems: [
      {label: 'Main', icon: 'home', href: '/Main'},
      {label: 'Request List', icon: 'bar', href: '/RequestList'},
      {label: 'Complete List', icon: 'bar', href: '/CompleteList'}
    ]
  }),
  methods: {
    ...mapActions({
      'loadSettings': 'settings/load',
      'initLines': 'productionStatus/initLines',
      'loadLogged': 'user/load'
    }),
    ...mapMutations({
      'loadToken': 'user/loadToken',
      'removeToken': 'user/removeToken'
    }),
    frame () { return this.$refs.frame },
    initErrorHandler () {
      api.errorHandler = (e) => {
        console.log('[partners] err, ', e)
        if (e.toString().endsWith('401') || e.toString().endsWith('422')) {
          this.removeToken()
          api.setToken(null)
          document.location = '?/Partners'
        }
      }
    },
    async tryToLoadSetting () {
      await this.loadSettings()
      this.initLines(this.settings.data.lines)
    },
    async loadSiteConfig () {
      await this.$loadScript('/static/site/config.js')
      lodash.extend(api, (window.site_config || {api: {}}).api)
      console.log('loadSiteConfig, ', api.host_biz)
    },
    async showNumberInput () {
      return this.$refs.numberInput.show()
    },
    go (href) {
      this.dialogMenu = false
      if (this.$router.history.current.path === href) { return }
      this.$router.push(href)
    },
    onClickLogout () {
      this.dialogMenu = false
      this.removeToken()
      api.setToken(null)
      document.location = '?/Partners'
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300&display=swap');
</style>

<style lang='less'>
@import '~@/assets/common.less';

html, body {
  height:100%; overflow:hidden;
  margin: 0px;
  touch-action: manipulation;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

#app:extend(.full-screen, .absolute) {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app.partners {
  .app-frame .title-area {
    background-color: #317a40;
  }

  .menu .menu-area {
    background-color: #317a40;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partners/index.vue